/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DjPsychoGameAssets} from "../DjPsychoGameAssets";
import {DjPsycho} from "../DjPsycho";
import {DjPsychoGameMode} from "../server/DjPsychoGameMode";
import {TimelineLite} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";

export class DjPsychoBackgroundElements extends PIXI.Container implements StageLayer {

    private _backgroundContainer: PIXI.Container;
    private _backgroundMain: PIXI.Sprite;
    private _backgroundMainXBet: PIXI.Sprite;
    private _mainView: PIXI.Container;
    private _backgroundFS: PIXI.Sprite;
    private _backgroundSFS: PIXI.Sprite;
    private _mainLogo: PIXI.Sprite;
    private _fsLogo: PIXI.Sprite;
    private _sfsLogo: PIXI.Sprite;
    private _staticContainer: PIXI.Container;

    constructor() {
        super();
        this.name = "DjPsychoBackgroundElements";
        this.init();
    }

    public setMode(): void {
        const mode: string = DjPsycho.model.data.nextMode;

        if (mode.indexOf(DjPsychoGameMode.FREESPIN_SUPER) > -1) {
            this.swapBackgroundTo(this._backgroundSFS);
            this._mainLogo.alpha = 0;
            this._fsLogo.alpha = 0;
            this._sfsLogo.alpha = 1;
        } else if (mode.indexOf(DjPsychoGameMode.FREESPIN) > -1) {
            this.swapBackgroundTo(this._backgroundFS);
            this._mainLogo.alpha = 0;
            this._fsLogo.alpha = 1;
            this._sfsLogo.alpha = 0;
        } else {
            this.swapBackgroundTo(this._backgroundMain);
            this._mainLogo.alpha = 1;
            this._fsLogo.alpha = 0;
            this._sfsLogo.alpha = 0;
        }
    }

    // #120
    public switchBgFromXBet(xBetOn: boolean): void {
        if (DjPsycho.model.isRestore && (DjPsycho.model.data.mode.indexOf("FREESPIN") > -1 || DjPsycho.model.data.nextMode.indexOf("FREESPIN") > -1)) {
            return;
        }

        const tl: TimelineLite = new TimelineLite(),
            duration: number = 6 / 30,
            outBg: PIXI.Sprite = (xBetOn ? this._backgroundMain : this._backgroundMainXBet),
            inBg: PIXI.Sprite = (xBetOn ? this._backgroundMainXBet : this._backgroundMain);

        tl.to(outBg, {
            duration: duration,
            alpha: 0
        }, 0);
        tl.to(inBg, {
            duration: duration,
            alpha: 1
        }, 0);
    }

    public onResize() {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        this._mainLogo.visible = true;
        if (NolimitApplication.isLandscape) {
            if (bounds.width <= 970) {
                this._mainLogo.visible = false;
            }
            this._mainLogo.position.set(-252, 28);
            this._mainLogo.scale.set(0.7);
        } else {
            this._mainLogo.position.set(182, -250);
            this._mainLogo.scale.set(1);
            if (bounds.height <= 970) {
                this._mainLogo.position.set(250, -120);
                this._mainLogo.scale.set(0.7);
            }
        }
        this._fsLogo.position = this._mainLogo.position;
        this._fsLogo.scale = this._mainLogo.scale;
        this._fsLogo.visible = this._mainLogo.visible;

        this._sfsLogo.position = this._mainLogo.position;
        this._sfsLogo.scale = this._mainLogo.scale;
        this._sfsLogo.visible = this._mainLogo.visible;
    }

    private init(): void {
        this._mainView = new PIXI.Container();
        this._backgroundContainer = new PIXI.Container();
        this._staticContainer = new PIXI.Container;

        const prefix: string = (DjPsycho.apiPlugin.gameClientConfiguration.useCensoredGfx ? "snowflake/" : "");

        this._backgroundMain = new PIXI.Sprite(DjPsycho.assetLoader.getTextures(prefix + DjPsychoGameAssets.MAIN_GAME_BACKGROUND)[0]);
        this._backgroundMain.anchor.set(0.5);

        this._backgroundMainXBet = new PIXI.Sprite(DjPsycho.assetLoader.getTextures(prefix + DjPsychoGameAssets.MAIN_GAME_BACKGROUND + "_X")[0]);
        this._backgroundMainXBet.anchor.set(0.5);
        this._backgroundMainXBet.alpha = 0;

        this._backgroundFS = new PIXI.Sprite(DjPsycho.assetLoader.getTextures(prefix + DjPsychoGameAssets.FS_BACKGROUND)[0]);
        this._backgroundFS.anchor.set(0.5);

        this._backgroundSFS = new PIXI.Sprite(DjPsycho.assetLoader.getTextures(DjPsychoGameAssets.SFS_BACKGROUND)[0]);
        this._backgroundSFS.anchor.set(0.5);

        this._mainLogo = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        this._fsLogo = new PIXI.Sprite(DjPsycho.assetLoader.getTextures(DjPsychoGameAssets.FS_LOGO)[0]);
        this._sfsLogo = new PIXI.Sprite(DjPsycho.assetLoader.getTextures(DjPsychoGameAssets.SFS_LOGO)[0]);

        this._backgroundContainer.addChild(this._backgroundMain, this._backgroundMainXBet);
        this._backgroundContainer.position.set(360);

        this._mainView.addChild(this._backgroundContainer);
        this._staticContainer.addChild(this._fsLogo);
        this._staticContainer.addChild(this._sfsLogo);
        this._staticContainer.addChild(this._mainLogo);

        this.addChild(this._mainView, this._staticContainer);
        this.setMode();
        this.onResize();
    }

    private swapBackgroundTo(newBackground: PIXI.Sprite): void {
        const oldBg: PIXI.DisplayObject = this._backgroundContainer.children[0],
            tl: TimelineLite = new TimelineLite(),
            duration: number = (12 / 30);

        newBackground.alpha = 0;
        this._backgroundContainer.addChildAt(newBackground, 0);

        tl.to(oldBg, {
            duration: duration,
            alpha: 0
        }, 0);
        tl.to(newBackground, {
            duration: duration,
            alpha: 1
        }, 0);
        tl.add(() => {
            if (this._backgroundContainer.children.length > 2) {
                this._backgroundContainer.removeChild(oldBg);
            }
        });
    }
}